import { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  Sun, Cloud, CloudSun, CloudFog, CloudDrizzle, CloudRain, CloudRainWind,
  CloudSnow, CloudLightning, MapPin, Loader2,
} from "lucide-react";

const ICON_MAP = {
  Sun, Cloud, CloudSun, CloudFog, CloudDrizzle, CloudRain, CloudRainWind,
  CloudSnow, CloudLightning,
};

function fmtToday() {
  const d = new Date();
  return {
    day: d.toLocaleDateString("en-IN", { weekday: "short" }),
    full: d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" }),
    time: d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false }),
  };
}

export default function WeatherWidget() {
  const [w, setW] = useState(null);
  const [now, setNow] = useState(fmtToday());
  const [err, setErr] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/weather");
        if (mounted) setW(data);
      } catch {
        if (mounted) setErr(true);
      }
    })();
    const tick = setInterval(() => setNow(fmtToday()), 30 * 1000);
    return () => { mounted = false; clearInterval(tick); };
  }, []);

  const Icon = w ? (ICON_MAP[w.icon] || Cloud) : Loader2;

  return (
    <div
      className="glass-strong rounded-xl px-4 py-2.5 flex items-center gap-4 text-sm"
      data-testid="weather-widget"
    >
      {/* Date + time */}
      <div className="leading-tight">
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{now.day}</div>
        <div className="font-display font-semibold text-[15px] text-white tabular">{now.full}</div>
      </div>

      <div className="h-9 w-px bg-white/10" />

      {/* Location */}
      <div className="leading-tight">
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 flex items-center gap-1">
          <MapPin className="h-2.5 w-2.5" />
          {w ? w.location : "Gurugram"}
        </div>
        <div className="font-display font-semibold text-[13px] text-white/90 tabular">{now.time}</div>
      </div>

      <div className="h-9 w-px bg-white/10" />

      {/* Weather */}
      <div className="flex items-center gap-2.5">
        <Icon
          className={`h-6 w-6 ${err ? "text-zinc-600" : (w?.is_day ? "text-amber-300" : "text-sky-300")} ${!w && !err ? "animate-spin" : ""}`}
          strokeWidth={1.75}
        />
        <div className="leading-tight">
          <div className="font-display font-bold text-[18px] text-white tabular">
            {w ? `${Math.round(w.temp_c)}°` : err ? "—" : "··"}
          </div>
          <div className="text-[10px] text-zinc-500 truncate max-w-[110px]">
            {w ? w.condition : err ? "Weather unavailable" : "Loading…"}
          </div>
        </div>
      </div>
    </div>
  );
}
